import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";

type Permission = { id: number; name: string };
type Admin = {
  permissions: Array<number>;
  subcategory_name: string | null;
  subcategory_id: number;
};

const CallParticipantSubCategories = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("callParticipantSubCategoriesCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("callParticipantSubCategoriesCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");


  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    if (!checkPermission("view_callparticipantticketsubcategory", "callparticipantticketsubcategory")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText);
    }
  }, [userPermissions,currentPage]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    const response = await fetch(
      `${webApi}/callparticipant/call_participant_sub_category/?page=${page}&page_size=${pageSize}&search=${searchText}`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };



  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setTotalCount(groupsData.total_count);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setCurrentPage(groupsData.current_page_number);
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    fetchData(currentPage, pageSize, value);
  };

  const columns = [
    {
      title: "Subcategory Name",
      dataIndex: "subcategory_name",
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_text: any, record: { subcategory_id: any }) => (
        <div className="d-flex align-items-center">
          {checkPermission("change_wizklubsubcategory", "wizklubsubcategory") && (
            <Link
              className="btn btn-icon btn-sm btn-soft-info rounded-pill"
              to={routes.editCallParticipantSubCategories}
              state={{ id: record.subcategory_id }}
            >
              <i className="feather-edit" />
            </Link>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Call Participant Sub Categories</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.crmLandingPage}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sub Categorties
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                {checkPermission("add_wizklubsubcategory", "wizklubsubcategory") && (
                  <Link to={routes.addCallParticipantSubCategories} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Sub Category
                  </Link>
                )}
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Sub Categorties List</h4>
              <div className="d-flex align-items-center flex-wrap"></div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin />{" "}
                  {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) => `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "30"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />)}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default CallParticipantSubCategories;
